import { render, staticRenderFns } from "./scanRecord.vue?vue&type=template&id=6affcd52&"
import script from "./scanRecord.vue?vue&type=script&lang=js&"
export * from "./scanRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6affcd52')) {
      api.createRecord('6affcd52', component.options)
    } else {
      api.reload('6affcd52', component.options)
    }
    module.hot.accept("./scanRecord.vue?vue&type=template&id=6affcd52&", function () {
      api.rerender('6affcd52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/oilActivityManage/scanActivity/scanRecord.vue"
export default component.exports